module.exports = __webpack_public_path__ + "static/media/phone.8ce73e64.svg";